const courses = {
  title: "Course",
  name: "Name",
  coursetype: "Course Type",
  coursetemplate: "Course Template",
  class: "Class",
  instructor: "Instructor",
  classroom: "Classroom",
  address: "Address",
  start: "Start",
  start_date: "Start Date",
  start_time: "Start Time",
  end: "End",
  end_date: "End Date",
  end_time: "End Time",
  enrolled_date: "Enrolled Date",
  theory_test: "Theory Test",
  met_up_days: "Met up days",
  type: "Type",
  course_completed: "Course Completed",
  completed: "Completed",
  ongoing: "Ongoing",
  status: "Status",
  diploma: "Course certificate",
  organisation: "Organisation",
}
export default courses
